<template>
	<div :class="['menu-mobile', getMenuState ? 'active' : '']">
		<ul class="niv-1">
			<li :class="[isHome ? 'active' : '']">
				<router-link @click.native="closeMenu" to="/">Home</router-link>
			</li>

			<li v-for="(item, i) in getMenuData.body.items" key="item" :class="[niv1Path === i + 1 ? 'active' : '', isHome && niv1Target === i + 1 ? 'active' : '', isHome && !niv1Target ? 'default' : '', getPostCategory === item.object_slug ? 'active' : '' ]">
				<router-link @click.native="closeMenu" :to="`/${item.object_slug}`">{{ item.title }}</router-link>
			</li>
		</ul>
	</div>
</template>

<script>
	import MenuMixin from '~mixins/Menu'

	export default {
		name: 'menu-mobile',
		mixins: [MenuMixin],
		methods: {
			closeMenu () {
				this.$store.commit('setMenuState', false)
			}
		},
		computed: {
			getMenuState () {
				return this.$store.getters.getMenuState
			}
		}
	}
</script>

<style lang="scss">
	.menu-mobile {
		position: fixed;
		z-index: 40;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		background: $basic_white;
		transform: translateX(-100%);
		transition: all .6s cubic-bezier(0.215, 0.61, 0.355, 1);

		&.active {
			transform: translateX(0);
		}

		ul {
			padding: 0;
			margin: 0;
		}

		li {
			list-style-type: none;
			margin-bottom: 5vh;
			text-align: center;

			&:last-child {
				margin-bottom: 0;
			}

			a {
				position: relative;
				@include fontSize(30);

				&::after {
					position: absolute;
					right: 0;
					bottom: 0;
					left: 0;
					height: 2px;
					background: $basic_black;
					opacity: 0;
					content: '';
					@include transition(all .4s);
				}
			}

			&.active a::after {
				opacity: 1;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/vue/components/common/header/MenuMobile.vue?dd796ba8